<div class="app-input">
    @if (label) {
        <mat-label [class]="required ? 'required-field' : ''">{{ label | translate }}</mat-label>
    }
    <mat-form-field class="mat-form-field" appearance="outline" [class]="readonly ? 'mat-mdc-form-field-disabled' : ''">
        <input
            appNoScriptTag
            matInput
            [placeholder]="placeholder | translate"
            [value]="value | translate"
            [formControl]="control"
            [readonly]="readonly"
            [required]="required"
            (blur)="afterBlur.emit($event)"
            (focus)="afterFocus.emit($event)"
            (input)="afterInput.emit($event)"
            [type]="type"
            [matTooltip]="(control.value | translate) || (placeholder | translate)"
            [min]="minValue"
            [max]="maxValue"
            [minlength]="minLength"
            [maxlength]="maxLength"
        />
        @if (isRightIcon) {
            <img class="input-icon" [src]="rightIconPath" alt="icon" matSuffix (click)="afterIconClick.emit(iconPositions.RIGHT)" />
        }
        @if (isLeftIcon) {
            <img class="input-icon" [src]="leftIconPath" alt="icon" matPrefix (click)="afterIconClick.emit(iconPositions.LEFT)" />
        }
        @if (control.invalid) {
            <mat-error>{{ getErrorMessage() | translate }}</mat-error>
        }
    </mat-form-field>
</div>
